import getStore from './getStore';
/** An alias for `getStore()` */

const globalBox = getStore;
export { getStore, globalBox };